<template>
  <div class="appointment-timeline">
    <div class="label">{{ $t("feature.homecare.appointment_detail") }}</div>
    <div v-if="appointments.length === 0">
      -
    </div>
    <div class="appointments pt-3" v-if="appointments.length > 0">
      <div
        v-for="(appointment, i) in sortAppointMent"
        class="appointment"
        :key="i"
        :class="{}"
      >
        <div class="date">
          <div class="day">
            {{ appointment.appointment_date | moment-day }}
          </div>
          <div class="month">
            {{ appointment.appointment_date | moment-month }}
          </div>
        </div>
        <div class="text">
          <div>
            <strong>{{
              $t(
                "feature.homecare.appointment_status." +
                  appointment.appointment_code
              )
            }}</strong>
          </div>
          <div>
            {{ $t("feature.homecare.estimate_time") }}
            {{ appointment.appointment_date | moment-time }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    appointments: {
      type: Array
    }
  },
  computed: {
    sortAppointMent() {
      const sort = this.appointments.sort((a, b) => {
        const dateA = new Date(a.appointment_date);
        const dateB = new Date(b.appointment_date);
        if (dateA < dateB) return 1;
        if (dateA > dateB) return -1;
        return 0;
      });
      return sort;
    }
  }
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 11px;
  font-weight: 500;
  color: #8c8786;
}
.appointment {
  $boxPadding: 30px;
  $bulletSize: 12px;
  position: relative;
  margin-left: $boxPadding;
  display: flex;
  flex-direction: row;
  padding: 13px 15px;
  border-radius: 15px;
  border: solid 1px #f0f0f0;
  margin-bottom: 16px;
  color: #8c8786;
  color: #000000;
  &::before {
    content: "";
    position: absolute;
    border-radius: 50%;
    background: #8c8786;
    width: $bulletSize;
    height: $bulletSize;
    top: 50%;
    margin-top: -$bulletSize / 2;
    left: -$boxPadding;
    z-index: 1;
  }
  &::after {
    content: "";
    position: absolute;
    width: 1px;
    background: #8c8786;
    height: calc(100% + 20px);
    top: 50%;
    margin-top: -$bulletSize / 2;
    left: -$boxPadding + ($bulletSize / 2);
  }
  &:last-child::after {
    content: none;
  }
  .text {
    align-self: center;
    font-size: 14px;
  }
  .date {
    font-size: 14px;
    font-weight: 500;
    margin-right: 24px;
    .day {
      line-height: 1.13;
      font-size: 24px;
      font-weight: bold;
    }
  }
  &.active {
    color: #000000;
    &::before {
      background: #00b793;
    }
    &::after {
      background: #00b793;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/homecare/AppointmentTimeline.vue